import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=dc0d1b80&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"
import style0 from "./premium.vue?vue&type=style&index=0&id=dc0d1b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0d1b80",
  null
  
)

export default component.exports